<div class="position-relative d-flex flex-column h-100  text-grey"
cdkDrag cdkDragRootElement=".cdk-overlay-pane"
cdkDragBoundary="body"
[cdkDragDisabled]="!toogleDialog">
<div class="modal-header jobDialogHeader text-grey" cdkDragHandle>
  <h4 class="modal-title synchpc-primary" id="modal-title">
    Create Registry
  </h4>
  <i
  style="z-index: 1"
  class="bi bi-dash text-danger"
  [ngClass]="{
    'bi-dash-lg': !toogleDialog,
    'bi-fullscreen': toogleDialog,
    'minmax-dialog': toogleDialog
  }"
  color="warn"
  (click)="toogleDialogMinMax()"
  [title]="toogleDialog ? 'Maximize' : 'Minimize'"
  ></i>
  <i
  style="z-index: 1"
  class="bi bi-x-lg text-danger mx-3"
  color="warn"
  (click)="onCancel()"
  title="Close"
  ></i>
</div>
<div class="modal-body jobDialogBody text-grey">
  <form
    name="createRegistryForm"
    [formGroup]="createRegistryForm"
    autocomplete="off"
    spellcheck="false"
  >
  <div class="h-100 d-flex flex-column">
    <div class="flex-grow-1">
      <div class="form-row">
        <div class="form-col">
          <mat-form-field >
            <mat-label>Registry Name</mat-label>
            <input
            matInput
            maxlength="36"
            placeholder="Registry Name"
            formControlName="name"
            />
            <mat-error
              *ngIf="createRegistryForm.get('name')?.hasError('required') && createRegistryForm.get('name')?.touched">
              Registry name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-col">
          <mat-form-field >
            <mat-label>Port</mat-label>
            <input
            matInput
            maxlength="20"
            placeholder="Port"
            formControlName="port"
            />
            <mat-error
              *ngIf="createRegistryForm.get('port')?.hasError('required') && createRegistryForm.get('port')?.touched">
              Registry port is required
            </mat-error>
            <mat-error
              *ngIf="createRegistryForm.get('port')?.hasError('pattern') && createRegistryForm.get('port')?.touched">
              Port must be a valid number
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    <div class="form-row">
      <div class="form-col">
        <mat-form-field >
          <mat-label>Domain</mat-label>
          <input
          matInput
          maxlength="36"
          placeholder="eg. localhost"
          formControlName="domain"
          />
          <mat-error
            *ngIf="createRegistryForm.get('domain')?.hasError('required') && createRegistryForm.get('domain')?.touched">
            Registry domain is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-col">
        <mat-form-field >
          <mat-label>Restart Policy</mat-label>
            <mat-select formControlName="restartPolicy">
              <mat-option [value]="'always'" selected>
                Always
              </mat-option>
              <mat-option [value]="'no'">
                No
              </mat-option>
              <!-- <mat-option [value]="'on-failure'">
                On Failure
              </mat-option> -->
              <mat-option [value]="'unless-stopped'">
                Unless Stopped
              </mat-option>
            </mat-select>
          <!-- <input
          matInput
          maxlength="20"
          placeholder="Restart Policy"
          formControlName="restartPolicy"
          /> -->
          <mat-error
            *ngIf="createRegistryForm.get('restartPolicy')?.hasError('required') && createRegistryForm.get('restartPolicy')?.touched">
            Restart Policy is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
</form>
  
</div>
<div class="modal-footer jobDialogFooter text-grey">
  <div class="w-100 d-flex align-items-center">
    <div class="d-flex d-flex justify-content-end w-100">
      <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="onCancel()"
      >
      Close
    </button>
    <button
    type="button"
    class="btn btn-primary ms-2"
    (click)="createRegistry()"
    >
    Submit
  </button>
</div>
</div>
</div>
<ngx-spinner
bdColor="rgba(0,0,0,0)"
size="default"
zIndex="1"
color="var(--s-primary-color)"
type="ball-spin"
[fullScreen]="false"
name="createRegistry"
>
<p class="pleaseWait text-grey">Please wait ...</p>
</ngx-spinner>
</div>
